import { render } from "./SubscriptionEditing.vue?vue&type=template&id=dd2e182e&ts=true"
import script from "./SubscriptionEditing.vue?vue&type=script&lang=ts"
export * from "./SubscriptionEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__